
import { useState, useEffect } from 'react';

const CAMPAIGN_END_DATE = new Date('2025-02-28T23:59:59+09:00');

interface CampaignState {
  isActive: boolean;
  timeLeft: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
  discountRate: number;
  discountLabel: string;
}

export default function useCampaign(): CampaignState {
  const [isActive, setIsActive] = useState(() => {
    return new Date().getTime() < CAMPAIGN_END_DATE.getTime();
  });

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculate = () => {
      const now = new Date();
      const diff = CAMPAIGN_END_DATE.getTime() - now.getTime();

      if (diff <= 0) {
        setIsActive(false);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setIsActive(true);
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };

    calculate();
    const timer = setInterval(calculate, 1000);
    return () => clearInterval(timer);
  }, []);

  return {
    isActive,
    timeLeft,
    discountRate: 30,
    discountLabel: '初回30%OFF',
  };
}
